define('presentation/welcome/validators/onboardingIdentityValidator',[
        'common/collections/enumerationValidator',
        'common/converters/phoneNumberFormatter',
        'constants/companySizeEnumerations',
        'constants/countryEnumerations',
        'constants/liveReceptionistScriptAgentToneConstants',
        'constants/marketingIndustryEnumerations',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule',
        'presentation/common/validation/validPhoneNumberSpecification'
    ],
    function() {
        return function() {
            let self = this;

            let _facade = null;
            let _viewModel = null;
            let _commonValidator = null;

            const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
            const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

            const PhoneNumberFormatter = require('common/converters/phoneNumberFormatter');
            const _phoneNumberFormatter = new PhoneNumberFormatter();

            const ValidPhoneNumberSpecificationConstructor = require('presentation/common/validation/validPhoneNumberSpecification');
            const _validPhoneNumberSpecification = new ValidPhoneNumberSpecificationConstructor();

            const _agentTones = require('constants/liveReceptionistScriptAgentToneConstants');
            const _companySizes = require('constants/companySizeEnumerations');
            const _countryEnumerations = require('constants/countryEnumerations');
            const _enumerationValidator = require('common/collections/enumerationValidator');
            const _industries = require('constants/marketingIndustryEnumerations');

            self.registerViewModel = (viewModel, facade) => {

                _viewModel = viewModel;
                _facade = facade;
                _commonValidator = new CommonValidatorConstructor(_viewModel);

                const validationRules = new ValidationRulesConstructor();
                validationRules.field("businessName")
                    .addValidationKeyUp(_commonValidator.isStringWithValue)
                    .addValidationI18n(_commonValidator.isStringWithValue, 'onboardingIdentity:businessNameRequired');
                validationRules.field("businessDescription")
                    .addValidationKeyUp(_commonValidator.isStringWithValue)
                    .addValidationI18n(_commonValidator.isStringWithValue, 'onboardingIdentity:businessDescriptionRequired');
                validationRules.field("agentTone")
                    .addValidationKeyUp(_validateAgentTone)
                    .addValidationI18n(_validateAgentTone, 'onboardingIdentity:pleaseMakeSelection');
                validationRules.field("industry")
                    .addValidationKeyUp(_validateIndustry)
                    .addValidationI18n(_validateIndustry, 'onboardingIdentity:pleaseMakeSelection');
                validationRules.field("numberOfEmployees")
                    .addValidationKeyUp(_validateCompanySize)
                    .addValidationI18n(_validateCompanySize, 'onboardingIdentity:pleaseMakeSelection');
                validationRules.array("mayForwardFromNumbers")
                    .arrayField("number")
                    .addValidationKeyUp(_validatePhoneNumber)
                    .addValidationI18n(_isForwardFromNumberProvided, 'onboardingIdentity:phoneNumberRequired')
                    .addValidationI18n(_validatePhoneNumber, 'phoneNumberInvalid')
                    .addValidationI18n(_isPhoneNumberUnique, 'phoneNumberDuplicate');

                validationRules.validationGroupKeyUp('isValid', ['businessName', 'businessDescription', 'agentTone', 'industry', 'numberOfEmployees' ]);

                _commonValidator.setValidationRules(validationRules);
            };

            self.validate = () => {
                return _commonValidator.validate();
            };

            const _validateAgentTone = (agentTone) => {
                return _enumerationValidator.isEnumerationValueValid(_agentTones, agentTone);
            };

            const _validateCompanySize = (companySize) => {
                return _enumerationValidator.isEnumerationKeyPresent(_companySizes, companySize);
            };

            const _validateIndustry = (industry) => {
                return _enumerationValidator.isEnumerationValueValid(_industries, parseInt(industry));
            };

            const _isForwardFromNumberProvided = (phoneNumber) => {
                if (_viewModel.shouldDisplayForwardFromNumbers() !== true) {
                    return true;
                }
                if (_commonValidator.isStringWithValue(phoneNumber)) {
                    return true;
                }
                return _viewModel.mayForwardFromNumbers()
                    .some((forwardFromNumber) => _commonValidator.isStringWithValue(forwardFromNumber.number()));
            };

            const _validatePhoneNumber = (phoneNumber) => {
                if (_commonValidator.isStringWithValue(phoneNumber)) {
                    let cleanPhoneNumber = _phoneNumberFormatter.clean(phoneNumber);
                    return _validPhoneNumberSpecification.isSatisfiedBy(cleanPhoneNumber, _countryEnumerations.usa);
                } else {
                    return true;
                }
            };

            const _isPhoneNumberUnique = (phoneNumber) => {
                if (_commonValidator.isStringWithValue(phoneNumber) === false) {
                    return true;
                }
                const mayForwardFromNumbers = _viewModel.mayForwardFromNumbers();
                const matchingPhoneNumbers = mayForwardFromNumbers.filter((s) => {
                    return _phoneNumberFormatter.clean(s.number().trim()) ===  _phoneNumberFormatter.clean(phoneNumber.trim());
                });
                return matchingPhoneNumbers.length === 1;
            };

        };
    });
